// Helper function to trim company suffixes
export const trimCompanySuffix = (name) => {
  if (!name || typeof name !== "string") return "";

  const suffixes = [
    "PUBLIC LIMITED COMPANY",
    "LIMITED",
    "LTD",
    "PLC",
    "PVT",
    "LLC",
    "LP",
    "Inc\\.?",
    "Incorporated",
    "LLP",
    "CLG",
  ];

  const suffixRegex = new RegExp(
    `\\s*(${suffixes.map((s) => s.replace(/\s+/g, "\\s+")).join("|")})$`,
    "i"
  );

  return name.replace(suffixRegex, "").trim();
};

// Helper function to check if a name contains abbreviated company suffixes
export const isNameAbbreviated = (name) => {
  if (!name || typeof name !== "string") return false;

  const abbreviatedSuffixes = ["LTD", "PLC", "PVT", "LLC", "LP", "LLP", "CLG"];
  const nonAbbreviatedSuffixes = ["PUBLIC LIMITED COMPANY", "LIMITED"];

  const abbreviatedRegex = new RegExp(
    `\\b(${abbreviatedSuffixes.join("|")})$`,
    "i"
  );
  const nonAbbreviatedRegex = new RegExp(
    `\\s*(${nonAbbreviatedSuffixes
      .map((s) => s.replace(/\s+/g, "\\s+"))
      .join("|")})$`,
    "i"
  );

  return (
    abbreviatedRegex.test(name.trim()) && !nonAbbreviatedRegex.test(name.trim())
  );
};
